import $ from 'jquery';
import fetch from 'utils/fetch';
import { bootstrapUI } from 'plugins/bootstrap';
import { displayCreate } from './api';
import { bindForm } from './';
import { bindCreationGeocoding } from 'modules/saas/customers';

export const displayCreationModal = (evt, savedCb) => {
  const $button = $(evt.target);

  $button.addClass('loading');
  displayCreate().then(modal => {
    $button.removeClass('loading');
    // Appending modal to content then handling behavior

    $(document.body).append(modal);
    const $modal = $('#modal-create-customer');

    const bootstrapForm = () => {
      bootstrapUI($modal);
      bindForm();
    };

    $modal
      .modal({
        onVisible: () => {
          const $submitBt = $modal.find('.button.approve');

          bindCreationGeocoding($modal.find('.companyForm'));
          bindCreationGeocoding($modal.find('.particularForm'), true);

          bootstrapForm();

          const $forms = $modal.find('form');
          $forms.on('submit', evt => {
            evt.preventDefault();

            const $form = $(evt.target);

            // Serializing and submitting form
            const data = new FormData($form[0]);
            const action = $form.attr('action');

            $submitBt.addClass('loading');

            fetch(action, {
              method: 'POST',
              body: data,
            }).then(
              res => {
                $submitBt.removeClass('loading');

                // Calling callback
                res
                  .json()
                  .then(customer => savedCb(customer))
                  .then(_ => $modal.modal('hide'));
              },
              err => {
                console.log('Error attempting to create customer', err);
                $submitBt.removeClass('loading');

                // Displaying validation error
                err.res.text().then(content => {
                  $form.html(content);

                  bindCreationGeocoding($modal.find('.companyForm'));
                  bindCreationGeocoding($modal.find('.particularForm'), true);

                  bootstrapForm();
                });
              }
            );

            return false;
          });
        },
        onHidden: () => {
          $modal.find('form').trigger('reset');
          $modal.remove();
        },
        onApprove: element => {
          const $form = $(element)
            .closest('.modal')
            .find('form:visible');
          $form.trigger('submit');

          return false;
        },
      })
      .modal('show');
  });
};



// WEBPACK FOOTER //
// ./src/modules/saas/customers/modals.js